module.exports = __webpack_public_path__ + "img/trip_list_empty_state@3x.782dc51.png";